import AC from '../img/logo/logo_AC.svg'
import AL from '../img/logo/logo_AL.svg'
import AM from '../img/logo/logo_AM.svg'
import AP from '../img/logo/logo_AP.svg'
import BA from '../img/logo/logo_BA.svg'
import CE from '../img/logo/logo_CE.svg'
import DF from '../img/logo/logo_DF.svg'
import ES from '../img/logo/logo_ES.svg'
import GO from '../img/logo/logo_GO.svg'
import MA from '../img/logo/logo_MA.svg'
import MG from '../img/logo/logo_MG.svg'
import MS from '../img/logo/logo_MS.svg'
import MT from '../img/logo/logo_MT.svg'
import PA from '../img/logo/logo_PA.svg'
import PB from '../img/logo/logo_PB.svg'
import PE from '../img/logo/logo_PE.svg'
import PI from '../img/logo/logo_PI.svg'
import PR from '../img/logo/logo_PR.svg'
import RJ from '../img/logo/logo_RJ.svg'
import RN from '../img/logo/logo_RN.svg'
import RO from '../img/logo/logo_RO.svg'
import RR from '../img/logo/logo_RR.svg'
import RS from '../img/logo/logo_RS.svg'
import SC from '../img/logo/logo_SC.svg'
import SE from '../img/logo/logo_SE.svg'
import SP from '../img/logo/logo_SP.svg'
import TO from '../img/logo/logo_TO.svg'
import GE from '../img/carmem.svg'

const atendimentos =
  [
    {
      uf: 'SP',
      uf_name: 'São Paulo',
      logo: SP,
      conector: 'em',
      generic: true,
      endereco: [
        {
          address: 'Av. Engenheiro Luiz Carlos Berrini, 1140 - Cidade Monções-Zona Sul - São Paulo/SP',
          cep: null,
          city: '',
          pagina: 'detetive-particular-sao-paulo.html',
          telefone: [
            {
              cidade: 'São Paulo',
              contato: '+558000000163',
              principal: true,
              mensagem: null,
              whatsapp: true,
              isVisibilty: true
            },
            {
              cidade: 'São Paulo',
              contato: '+5511975775395',
              principal: false,
              mensagem: null,
              whatsapp: true,
              isVisibilty: true
            }
          ]
        }
      ]
    },
    {
      uf: 'BA',
      uf_name: 'Bahia',
      logo: BA,
      conector: 'em',
      generic: true,
      endereco: [
        {
          address: 'Avenida Tancredo Neves, 620 ',
          cep: '41820-020',
          city: 'Salvador/BA',
          pagina: 'detetive-particular-salvador.html',
          telefone: [
            {
              cidade: 'Salvador/BA',
              contato: '+558000000163',
              principal: true,
              mensagem: null,
              whatsapp: true,
              isVisibilty: true
            },
            {
              cidade: 'Salvador/BA',
              contato: '+5571999419252',
              principal: false,
              mensagem: null,
              whatsapp: true,
              isVisibilty: true
            }
          ]
        }
      ]
    },
    {
      uf: 'RO',
      uf_name: 'Rondônia',
      logo: RO,
      conector: 'em',
      generic: true,
      endereco: [
        {
          address: null,
          cep: null,
          city: null,
          telefone: [
            {
              cidade: 'Rondônia',
              contato: '+558000000163',
              principal: true,
              mensagem: null,
              whatsapp: true,
              isVisibilty: true
            }
          ]
        }
      ]
    },
    {
      uf: 'AC',
      uf_name: 'Acre',
      logo: AC,
      conector: 'em',
      generic: true,
      endereco: [
        {
          address: null,
          cep: null,
          city: null,
          telefone: [
            {
              cidade: 'Acre',
              contato: '+558000000163',
              principal: true,
              mensagem: null,
              whatsapp: true,
              isVisibilty: true
            }
          ]
        }
      ]
    },
    {
      uf: 'PA',
      uf_name: 'Pará',
      logo: PA,
      conector: 'em',
      generic: true,
      endereco: [
        {
          address: null,
          cep: null,
          city: null,
          telefone: [
            {
              cidade: 'Pará',
              contato: '+558000000163',
              principal: true,
              mensagem: null,
              whatsapp: true,
              isVisibilty: true
            }
          ]
        }
      ]
    },
    {
      uf: 'RR',
      uf_name: 'Roraima',
      logo: RR,
      conector: 'em',
      generic: true,
      endereco: [
        {
          address: null,
          cep: null,
          city: null,
          telefone: [
            {
              cidade: 'Roraima',
              contato: '+558000000163',
              principal: true,
              mensagem: null,
              whatsapp: true,
              isVisibilty: true
            }
          ]
        }
      ]
    },
    {
      uf: 'AM',
      uf_name: 'Amazonas',
      logo: AM,
      conector: 'em',
      generic: true,
      endereco: [
        {
          address: null,
          cep: null,
          city: null,
          telefone: [
            {
              cidade: 'Amazonas',
              contato: '+558000000163',
              principal: true,
              mensagem: null,
              whatsapp: true,
              isVisibilty: true
            }
          ]
        }
      ]
    },
    {
      uf: 'AP',
      uf_name: 'Amapá',
      logo: AP,
      conector: 'em',
      generic: true,
      endereco: [
        {
          address: null,
          cep: null,
          city: null,
          telefone: [
            {
              cidade: 'Amapá',
              contato: '+558000000163',
              principal: true,
              mensagem: null,
              whatsapp: true,
              isVisibilty: true
            }
          ]
        }
      ]
    },
    {
      uf: 'MT',
      uf_name: 'Mato Grosso',
      logo: MT,
      conector: 'em',
      generic: true,
      endereco: [
        {
          address: 'Avenida Fernando Corrêa da Costa, 567-Areão',
          cep: '78088-800',
          city: 'Cuiabá / MT',
          pagina: 'detetive-particular-cuiaba.html',
          telefone: [
            {
              cidade: 'Cuiabá / MT',
              contato: '+558000000163',
              principal: true,
              mensagem: null,
              whatsapp: true,
              isVisibilty: true
            },
            {
              cidade: 'Cuiabá / MT',
              contato: '+5565996854929',
              principal: false,
              mensagem: null,
              whatsapp: true,
              isVisibilty: true
            }
          ]
        }
      ]
    },
    {
      uf: 'TO',
      uf_name: 'Tocantins',
      logo: TO,
      conector: 'em',
      generic: true,
      endereco: [
        {
          address: null,
          cep: null,
          city: null,
          telefone: [
            {
              cidade: 'Tocantins',
              contato: '+558000000163',
              principal: true,
              mensagem: null,
              whatsapp: true,
              isVisibilty: true
            }
          ]
        }
      ]
    },
    {
      uf: 'MA',
      uf_name: 'Maranhão',
      logo: MA,
      conector: 'em',
      generic: true,
      endereco: [
        {
          address: null,
          cep: null,
          city: null,
          telefone: [
            {
              cidade: 'Maranhão',
              contato: '+558000000163',
              principal: true,
              mensagem: null,
              whatsapp: true,
              isVisibilty: true
            }
          ]
        }
      ]
    },
    {
      uf: 'SE',
      uf_name: 'Sergipe',
      logo: SE,
      conector: 'em',
      generic: true,
      endereco: [
        {
          address: null,
          cep: null,
          city: null,
          telefone: [
            {
              cidade: 'Sergipe',
              contato: '+558000000163',
              principal: true,
              mensagem: null,
              whatsapp: true,
              isVisibilty: true
            }
          ]
        }
      ]
    },
    {
      uf: 'PI',
      uf_name: 'Piauí',
      logo: PI,
      conector: 'em',
      generic: true,
      endereco: [
        {
          address: null,
          cep: null,
          city: null,
          telefone: [
            {
              cidade: 'Piauí',
              contato: '+558000000163',
              principal: true,
              mensagem: null,
              whatsapp: true,
              isVisibilty: true
            }
          ]
        }
      ]
    },
    {
      uf: 'CE',
      uf_name: 'Ceará',
      logo: CE,
      conector: 'em',
      generic: true,
      endereco: [
        {
          address: null,
          cep: null,
          city: null,
          telefone: [
            {
              cidade: 'Ceará',
              contato: '+558000000163',
              principal: true,
              mensagem: null,
              whatsapp: true,
              isVisibilty: true
            }
          ]
        }
      ]
    },
    {
      uf: 'AL',
      uf_name: 'Alagoas',
      logo: AL,
      conector: 'em',
      generic: true,
      endereco: [
        {
          address: null,
          cep: null,
          city: null,
          telefone: [
            {
              cidade: 'Alagoas',
              contato: '+558000000163',
              principal: true,
              mensagem: null,
              whatsapp: true,
              isVisibilty: true
            }
          ]
        }
      ]
    },
    {
      uf: 'PB',
      uf_name: 'Paraíba',
      logo: PB,
      conector: 'em',
      generic: true,
      endereco: [
        {
          address: null,
          cep: null,
          city: null,
          telefone: [
            {
              cidade: 'Paraíba',
              contato: '+558000000163',
              principal: true,
              mensagem: null,
              whatsapp: true,
              isVisibilty: true
            }
          ]
        }
      ]
    },
    {
      uf: 'PE',
      uf_name: 'Pernambuco',
      logo: PE,
      conector: 'em',
      generic: true,
      endereco: [
        {
          address: null,
          cep: null,
          city: null,
          telefone: [
            {
              cidade: 'Pernambuco',
              contato: '+558000000163',
              principal: false,
              mensagem: null,
              whatsapp: true,
              isVisibilty: true
            }
          ]
        }
      ]
    },
    {
      uf: 'RN',
      uf_name: 'Rio Grande do Norte',
      logo: RN,
      conector: 'em',
      generic: true,
      endereco: [
        {
          address: null,
          cep: null,
          city: null,
          telefone: [
            {
              cidade: 'Rio Grande do Norte',
              contato: '+558000000163',
              principal: false,
              mensagem: null,
              whatsapp: true,
              isVisibilty: true
            }
          ]
        }
      ]
    },
    {
      uf: 'RS',
      uf_name: 'Rio Grande do Sul',
      logo: RS,
      conector: 'em',
      generic: true,
      endereco: [
        {
          address: 'Avenida Carlos Gomes, 700',
          cep: '90480-000',
          city: 'Porto Alegre / RS',
          pagina: 'detetive-particular-porto-alegre.html',
          telefone: [
            {
              cidade: 'Porto Alegre / RS',
              contato: '+558000000163',
              principal: true,
              mensagem: null,
              whatsapp: true,
              isVisibilty: true
            },
            {
              cidade: 'Porto Alegre / RS',
              contato: '+5551996315328',
              principal: false,
              mensagem: null,
              whatsapp: true,
              isVisibilty: true
            }
          ]
        }
      ]
    },
    {
      uf: 'PR',
      uf_name: 'Paraná',
      logo: PR,
      conector: 'em',
      generic: true,
      endereco: [
        {
          address: 'Rua Comendador Araújo, 499 - Centro',
          cep: '80420-000',
          city: 'Curitiba / PR',
          pagina: 'detetive-particular-curitiba.html',
          telefone: [
            {
              cidade: 'Curitiba / PR',
              contato: '+558000000163',
              principal: true,
              mensagem: null,
              whatsapp: true,
              isVisibilty: true
            },
            {
              cidade: 'Curitiba / PR',
              contato: '+5541992132899',
              principal: false,
              mensagem: null,
              whatsapp: true,
              isVisibilty: true
            }
          ]
        }
      ]
    },
    {
      uf: 'SC',
      uf_name: 'Santa Catarina',
      logo: SC,
      conector: 'em',
      generic: true,
      endereco: [
        {
          address: 'Avenida Rio Branco, 404 - Centro',
          cep: '88015-200',
          city: 'Florianópolis / SC',
          pagina: 'detetive-particular-florianopolis.html',
          telefone: [
            {
              cidade: 'Florianópolis / SC',
              contato: '+558000000163',
              principal: true,
              mensagem: null,
              whatsapp: true,
              isVisibilty: true
            },
            {
              cidade: 'Florianópolis / SC',
              contato: '+5548991569380',
              principal: false,
              mensagem: null,
              whatsapp: true,
              isVisibilty: true
            }
          ]
        }
      ]
    },
    {
      uf: 'MG',
      uf_name: 'Minas Gerais',
      logo: MG,
      conector: 'em',
      generic: true,
      endereco: [
        {
          address: 'Av. do Contorno, 6594, 7º Andar, Savassi',
          cep: '30110-044',
          city: 'Belo Horizonte / MG',
          pagina: 'detetive-particular-belo-horizonte.html',
          telefone: [
            {
              cidade: 'Belo Horizonte / MG',
              contato: '+558000000163',
              principal: true,
              mensagem: null,
              whatsapp: true,
              isVisibilty: true
            },
            {
              cidade: 'Belo Horizonte / MG',
              contato: '+5531971980736',
              principal: false,
              mensagem: null,
              whatsapp: true,
              isVisibilty: true
            }
          ]
        }
      ]
    },
    {
      uf: 'RJ',
      uf_name: 'Rio de Janeiro',
      logo: RJ,
      conector: 'em',
      generic: true,
      endereco: [
        {
          address: 'Praia de Botafogo, 228, Ala A - Botafogo',
          cep: '22250-040',
          city: 'Rio de Janeiro / RJ',
          pagina: 'detetive-particular-rio-de-janeiro.html',
          telefone: [
            {
              cidade: 'Rio de Janeiro / RJ',
              contato: '+558000000163',
              principal: true,
              mensagem: null,
              whatsapp: true,
              isVisibilty: true
            },
            {
              cidade: 'Rio de Janeiro / RJ',
              contato: '+5521998798970',
              principal: false,
              mensagem: null,
              whatsapp: true,
              isVisibilty: true
            }
          ]
        }
      ]
    },
    {
      uf: 'ES',
      uf_name: 'Espírito Santo',
      logo: ES,
      conector: 'em',
      generic: true,
      endereco: [
        {
          address: null,
          cep: null,
          city: null,
          telefone: [
            {
              cidade: 'Espírito Santo',
              contato: '+558000000163',
              principal: true,
              mensagem: null,
              whatsapp: true,
              isVisibilty: true
            }
          ]
        }
      ]
    },
    {
      uf: 'MS',
      uf_name: 'Mato Grosso do Sul',
      logo: MS,
      conector: 'em',
      generic: true,
      endereco: [
        {
          address: null,
          cep: null,
          city: null,
          telefone: [
            {
              cidade: 'Mato Grosso do Sul',
              contato: '+558000000163',
              principal: true,
              mensagem: null,
              whatsapp: true,
              isVisibilty: true
            }
          ]
        }
      ]
    },
    {
      uf: 'GO',
      uf_name: 'Goiás',
      logo: GO,
      conector: 'em',
      generic: true,
      endereco: [
        {
          address: 'Avenida D, esquina com rua 9, 419',
          cep: '74150-040',
          city: 'Goiânia / GO',
          pagina: 'detetive-particular-goiania.html',
          telefone: [
            {
              cidade: 'Goiânia / GO',
              contato: '+558000000163',
              principal: true,
              mensagem: null,
              whatsapp: true,
              isVisibilty: true
            },
            {
              cidade: 'Goiânia / GO',
              contato: '+5562998646156',
              principal: false,
              mensagem: null,
              whatsapp: true,
              isVisibilty: true
            }
          ]
        }
      ]
    },
    {
      uf: 'DF',
      uf_name: 'Distrito Federal',
      logo: DF,
      conector: 'em',
      generic: true,
      endereco: [
        {
          address: null,
          cep: null,
          city: null,
          telefone: [
            {
              cidade: 'Distrito Federal',
              contato: '+558000000163',
              principal: true,
              mensagem: null,
              whatsapp: true,
              isVisibilty: true
            }
          ]
        }
      ]
    }
  ];

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  renderRegiao(uf) {
    if (uf === 'ge') {
      return { logo: GE }
    }
    if (!!uf) {
      const logo = atendimentos.filter(value => value.uf === uf.toUpperCase())
      return logo[0]
    }
  },

  renderContato(uf) {
    if (uf === 'ge') {
      const contato = atendimentos.filter(value => value.generic);
      const seenPhones = new Set();

      const address = contato.map((value, index) => {
        const end = { ...value.endereco[0] };

        end.telefone = end.telefone.filter(tel => {
          if (seenPhones.has(tel.contato)) {
            return false;
          }
          seenPhones.add(tel.contato);
          return true;
        });

        end.telefone = end.telefone.map(tel => ({ ...tel, principal: false }));

        return end;
      }).filter(end => end.address || end.telefone.length > 0);

      return address;
    }

    if (!!uf) {
      const logo = atendimentos.filter(value => value.uf === uf.toUpperCase())
      return logo[0].endereco
    }
  },

  renderLogoFone(uf) {
    if (uf === 'ge') {
      return { logo: GE, uf: "ge", telefone: ["+558000000163", "+5511975775395"] }
      //return { logo: GE, uf: "ge", telefone: ["+5511975775395"]}
    }
    if (!!uf) {
      const logo = atendimentos.filter(value => value.uf === uf.toUpperCase())
      const telefone = logo[0].endereco.map(value => {
        const tel = value.telefone.filter(res => res.isVisibilty)
        return tel.map(pr => pr.contato)
      })
      console.log('telefone:>>>> ', telefone)
      return {
        logo: logo[0].logo, uf: logo[0].uf_name, telefone: telefone[0], uf_code: logo[0].uf, uf_conector: logo[0].conector
      }
    }
  },

  renderTelVisivel(uf) {
    if (uf === 'ge') {
      return [
        { principal: false, contato: "+558000000163", whatsapp: true, isVisibilty: true },
        // {principal: false, contato: "+5531971980736", whatsapp: true},
        { principal: true, contato: "+5511975775395", whatsapp: false, isVisibilty: true },
      ]
    }

    if (!!uf) {
      const logo = atendimentos.filter(value => value.uf === uf.toUpperCase())
      const telefone = logo[0].endereco.map(value =>
        value.telefone.filter(res => res.isVisibilty)
      )
      return telefone[0]
    }
  }
}